import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from '../../app/constants'

const CriminalHistoryQuestion = () => ({
    "collection-agency":{
        header : "Criminal history",
        text : ["Have any of your directors, partners or officers been convicted for an offence for which they have not been pardoned?"],
        textRenewal : ["In the last year, have any of your directors, partners or officers been convicted of an offence for which they have not been pardoned?"],
        navigation : {
            yes : ROUTE_PATH.CRIMINAL_HISTORY_DETAILS,
            no : ROUTE_PATH.WORK_HISTORY_DETAILS
        },
        navigationRenewal : {
            yes : ROUTE_PATH.CRIMINAL_HISTORY_DETAILS,
            no : ROUTE_PATH.WORK_HISTORY_DETAILS
        }
    },
    "debt-management-agency":{
        header : "Criminal history",
        text : ["Have any of your directors, partners or officers been convicted for an offence for which they have not been pardoned?"],
        textRenewal : ["In the last year, have any of your directors, partners or officers been convicted of an offence for which they have not been pardoned?"],
        navigation : {
            yes : ROUTE_PATH.CRIMINAL_HISTORY_DETAILS,
            no : ROUTE_PATH.WORK_HISTORY_DETAILS
        },
        navigationRenewal : {
            yes : ROUTE_PATH.CRIMINAL_HISTORY_DETAILS,
            no : ROUTE_PATH.WORK_HISTORY_DETAILS
        }  
    },
    "collection-agency-collector" : {
        header : "Criminal history",
        text : ["Has the applicant been convicted for an offence for which they have not been pardoned?"],
        textRenewal : ["In the last year, has applicant been convicted for an offence for which they have not been pardoned?"],
        navigation : {
            yes : ROUTE_PATH.CRIMINAL_HISTORY_DETAILS,
            no : ROUTE_PATH.LICENCE_SUSPENSION_QUESTION
        },
        navigationRenewal : {
            yes : ROUTE_PATH.CRIMINAL_HISTORY_DETAILS,
            no : ROUTE_PATH.LICENCE_SUSPENSION_QUESTION
        } 
    },
    "debt-management-agent" : {
        header : "Criminal history",
        text : ["Has the applicant been convicted for an offence for which they have not been pardoned?"],
        textRenewal : ["In the last year, has applicant been convicted for an offence for which they have not been pardoned?"],
        navigation : {
            yes : ROUTE_PATH.CRIMINAL_HISTORY_DETAILS,
            no : ROUTE_PATH.LICENCE_SUSPENSION_QUESTION
        },
        navigationRenewal : {
            yes : ROUTE_PATH.CRIMINAL_HISTORY_DETAILS,
            no : ROUTE_PATH.LICENCE_SUSPENSION_QUESTION
        }
    }
    
})

const CriminalHistoryQuestionSlice = createSlice({
    name : 'criminalHistoryQuestion',
    initialState: CriminalHistoryQuestion(),
    reducers: {
        setCriminalHistoryQuestionAnswer(state, action) {
            state.crinimalHistoryQuestionAnswer = action.payload
        }
    }
})

export const {setCriminalHistoryQuestionAnswer} = CriminalHistoryQuestionSlice.actions

export const criminalHistoryQuestionReducer = CriminalHistoryQuestionSlice.reducer

const CriminalHistoryDetails = () => ({
    "collection-agency" :{
        header : "Criminal history",
        text : [
            "Provide full details about any offences committed by company directors, partners, or officers."
        ],
        headerRenewal : "Criminal history",
        textRenewal : [
            "Review the details about the offences committed by company directors, partners, or officers."
        ],
        navigation : {
            next : ROUTE_PATH.WORK_HISTORY_DETAILS,
        },
        navigationRenewal : {
            next : ROUTE_PATH.LICENCE_SUSPENSION_DETAILS
        }
    },
    "debt-management-agency" : {
        header : "Criminal history",
        text : [
            "Provide full details about any offences committed by company directors, partners, or officers."
        ],
        headerRenewal : "Criminal history",
        textRenewal : [
            "Review the details about the offences committed by company directors, partners, or officers."
        ],
        navigation : {
            next : ROUTE_PATH.WORK_HISTORY_DETAILS
        },
        navigationRenewal : {
            next : ROUTE_PATH.LICENCE_SUSPENSION_DETAILS
        }
    },
    "collection-agency-collector" : {
        header : "Criminal history",
        text : [
            "Provide full details about any offences."
        ],
        headerRenewal : "Criminal history",
        textRenewal : [
            "Review details about offences."
        ],
        navigation : {
            next : ROUTE_PATH.LICENCE_SUSPENSION_QUESTION,
        },
        navigationRenewal : {
            next : ROUTE_PATH.LICENCE_SUSPENSION_DETAILS
        }
    },
    "debt-management-agent" : {
        header : "Criminal history",
        text : [
            "Provide full details about any offences."
        ],
        headerRenewal : "Criminal history",
        textRenewal : [
            "Review details about offences committed."
        ],
        navigation : {
            next : ROUTE_PATH.LICENCE_SUSPENSION_QUESTION
        },
        navigationRenewal : {
            next : ROUTE_PATH.LICENCE_SUSPENSION_DETAILS
        }
    },
    header : "Criminal history",
    text : [""],
    headerRenewal : "Criminal history",
    textRenewal : [""],
    navigation : {
        next : ROUTE_PATH.WORK_HISTORY_DETAILS,
    },
    navigationRenewal : {
        next : ROUTE_PATH.LICENCE_SUSPENSION_DETAILS
    }
})

const CriminalHistoryDetailsSlice = createSlice({
    name : 'CriminalHistoryDetails',
    initialState: CriminalHistoryDetails(),
    reducers: {}      
})

export const criminalHistoryDetailsReducer = CriminalHistoryDetailsSlice.reducer
